<template>
  <SidebarBase>
    <nav class="flex flex-col py-8 space-y-4">
      <h4 class="h4 text-black font-alt sidebar-title-decorator" v-text="'Table of contents:'" />
      <ul class="flex flex-col space-y-4" v-if="navigationModel && navigationModel.length">
        <li v-for="{ id, name, href, items } in navigationModel" :key="id" class="flex flex-col space-y-4">
          <RouterLink
            class="pl-3 sidebar-link inline-flex text-base"
            :class="{ selected: activeHash === href }"
            :to="href"
          >
            {{ name }}
          </RouterLink>
          <ul class="flex flex-col space-y-3" v-if="items?.length">
            <li v-for="{ id, name, href } in items" :key="id">
              <RouterLink
                class="pl-8 sidebar-link inline-flex text-base"
                :class="{ selected: activeHash === href }"
                :to="href"
              >
                {{ name }}
              </RouterLink>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </SidebarBase>
</template>

<script setup lang="ts">
import { useScrollSpy } from '~/composables/useScrollSpy'

const props = defineProps<{
  navigationModel?: any[]
}>()

const { activeHash } = useScrollSpy(computed(() => props?.navigationModel))
</script>

<style lang="scss">
.sidebar-title-decorator {
  @apply relative;

  &::before {
    @screen lg {
      @apply w-[120px] h-[16px] absolute left-0 bottom-full -translate-y-4 content-[''];
      background: url('./images/top.svg') no-repeat;
    }
  }
}

.sidebar-link:not(.selected) {
  @apply text-gray-700 hover:text-gray-700 font-medium cursor-pointer;
}

.sidebar-link.selected {
  @apply relative text-blue-900 hover:text-blue-900 font-semibold pointer-events-none;

  &::before {
    @apply absolute left-0 inset-y-0 w-[2px] bg-blue-600 rounded-full content-[''];
  }
}
</style>
